export default __webpack_public_path__ + "assets/images/horizontal-dark-logo.png";